/**
 * Cross-tab single-flight for cookie refresh.
 *
 * In-tab coalescing lives in `api.ts` (`isRefreshing`). That does not span tabs:
 * when the access JWT expires, every open tab fires `/auth/session/renew` with the
 * same cookie and races server-side rotation. `navigator.locks` serializes the
 * network call across same-origin tabs (Chrome/Opera/Edge/Firefox).
 */
const LOCK_NAME = 'ofertator:auth-refresh'

export async function withAuthRefreshLock<T>(fn: () => Promise<T>): Promise<T> {
  const locks = typeof navigator !== 'undefined' ? navigator.locks : undefined
  if (locks?.request) {
    return locks.request(LOCK_NAME, fn)
  }
  return fn()
}
